/**********************************************************************
USER module
**********************************************************************/
const DEFAULT_USER_ID = null
const DEFAULT_AUTH_TOKEN = null

const STATE = {
  user_id: DEFAULT_USER_ID,
  auth_token: DEFAULT_AUTH_TOKEN,
}

const userModule = {
  namespace: true,
  state: STATE,
  actions: {
    logIn ({commit}, userData) {
      commit('logIn', userData)
    },
    logOut ({commit}) {
      commit('logOut')
    }
  },
  mutations: {
    logIn (state, data) {
      state.auth_token = data.token
      state.user_id = data.user
    },
    logOut (state) {
      state.auth_token = DEFAULT_AUTH_TOKEN
      state.user_id = DEFAULT_USER_ID
    }
  },
  getters: {
    getAuthToken: state => {
      return state.auth_token
    },
    getUserId: state => {
      return state.user_id
    },
    isLoggedIn: state => {
      return state.auth_token != null
    }
  }
}

export default userModule